import { isAfter } from "date-fns";
import { syncStatus } from "./contentSync";
import categoryTypes from "./contentCategory";

const _getLatestOrOlderDate = ({ dateArray, getOlder = false }) => {
  return dateArray
    .reduce((result, date) => {
      if (!result) {
        return date; 
      }

      return getOlder 
        ? (date < result ? date : result) 
        : (date > result ? date : result);
    }, null);
};

export const getTopicSyncStatus = ({ 
  topic, 
  topicCategoryType, 
  associatedAcademicMains 
}) => {
  const topicVersionAt = topic?.versionAt;

  const incompatibleCategoryTypes = [
    categoryTypes.WEBCONFERENCE,
    categoryTypes.SCORM,
    categoryTypes.H5P,
    categoryTypes.AVALIA
  ];

  if (incompatibleCategoryTypes.includes(topicCategoryType)) {
    return syncStatus.UNAVAILABLE_TO_SYNC;
  }

  let hasBatchProcessNewerThenTopicVersionAt = false;
  let isTopicNewerThenAssociated = false;
  
  const olderAssociatedVersionDate = _getLatestOrOlderDate({
    dateArray : associatedAcademicMains.map((a) => (new Date(a.versionAt))),
    getOlder  : true
  });

  const latestBatchProcessDate = _getLatestOrOlderDate({
    dateArray: associatedAcademicMains.map((a) => (new Date(a.batchProcessCreatedAt)))
  });
  
  if (!topic.children?.length) {
    isTopicNewerThenAssociated = isAfter(new Date(topicVersionAt), olderAssociatedVersionDate);

    hasBatchProcessNewerThenTopicVersionAt = isAfter(
      new Date(latestBatchProcessDate),
      new Date(topicVersionAt)
    );
  } else {
    const versions = [...topic.children.map((child) => child.versionAt), topicVersionAt];
    
    isTopicNewerThenAssociated = versions.some((versionAt) => isAfter(new Date(versionAt), olderAssociatedVersionDate));

    hasBatchProcessNewerThenTopicVersionAt = versions.some((versionAt) => isAfter(
      new Date(latestBatchProcessDate),
      new Date(versionAt)
    ));
  }

  if (topicVersionAt && !isTopicNewerThenAssociated) {
    return syncStatus.SYNCHRONIZED;
  }
    
  if (topicVersionAt && hasBatchProcessNewerThenTopicVersionAt) {
    const statusPriority = {
      [syncStatus.ERROR]            : 1,
      [syncStatus.WAITING_FOR_SYNC] : 2,
      [syncStatus.NOT_SYNCHRONIZED] : 3,
      [syncStatus.SYNCHRONIZED]     : 4
    };

    const statusByPriority = associatedAcademicMains.reduce((acc, associatedAcademicMain) => {
      if (statusPriority[associatedAcademicMain.syncStatus] < acc.priority) {
        acc.status = associatedAcademicMain.syncStatus;
        acc.priority = statusPriority[associatedAcademicMain.syncStatus];
      }
      return acc;
    }, { status: null, priority: 5 });
    
    return statusByPriority.status;
  } 
  
  return syncStatus.NOT_SYNCHRONIZED;
};